import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { __, green, grey, red } from '@web/birdz-angular';
import { ICellRendererParams } from 'ag-grid-community';
export interface CellKpiStateParams extends ICellRendererParams {
  kpiValue: string;
}

@Component({
  selector: 'app-cell-kpi-state',
  imports: [MatTooltip, MatIconModule],
  templateUrl: './cell-kpi-state.component.html',
  styleUrl: './cell-kpi-state.component.scss',
})
export class CellKpiStateComponent {
  icon = '';
  color = '';
  tooltip = '';

  constructor() {}

  agInit(params: CellKpiStateParams) {
    if (params.kpiValue === 'PENDING_CALCULATION') {
      this.icon = 'pending';
      this.color = grey;
      this.tooltip = __('KPI_PENDING_CALCULATION');
    } else if (params.kpiValue === 'OK') {
      this.icon = 'check_circle';
      this.color = green;
      this.tooltip = __('KPI_OK');
    } else if (params.kpiValue === 'KO') {
      this.icon = 'cancel';
      this.color = red;
      this.tooltip = __('KPI_KO');
    } else if (params.kpiValue === 'EXCLUDED') {
      this.icon = 'do_not_disturb_on';
      this.color = grey;
      this.tooltip = __('KPI_EXCLUDED');
    }
  }

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }
}
